import { render } from "./SearchPageCat.vue?vue&type=template&id=1160fe55&scoped=true"
import script from "./SearchPageCat.vue?vue&type=script&lang=js"
export * from "./SearchPageCat.vue?vue&type=script&lang=js"

import "./SearchPageCat.vue?vue&type=style&index=0&id=1160fe55&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1160fe55"]])

export default __exports__